























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import PanelsComponent from "./Panels/Panels.vue";
import FiltersComponent from "./Filters/Filters.vue";
import PanelDetailsComponent from "./Panels/PanelDetails.vue";
import FilterDetailsComponent from "./Filters/FilterDetails.vue";
import Loader from '@/shared/components/Loader.vue';
import ErrorMessagesComponent from '@/shared/components/ErrorMessages.vue';
import { IConfig } from '../models/config-model';
import IFilter from '../models/filter-model';

@Component({
  components: {
    PanelsComponent,
    FiltersComponent,
    PanelDetailsComponent,
    FilterDetailsComponent,
    Loader,
    ErrorMessagesComponent
  },
  computed: {
    ...mapGetters(["totalResults", "getActiveFilters", "getConfig", "root"]),
    ...mapState([
      "initialLoad",
      "loading",
      "filters",
      "panels",
      "labels",
      "showDetailPanel",
      "showDetailFilter",
      "config",
      "error"
    ]),
  },
})
export default class PanelFilterWidget extends Vue {
  @Prop() configRaw!: string;
  public config!: IConfig;
  public mobileFiltersOpened: boolean = false;
  private loaderText = /*this.$props.config.language === 'nl' ? 'Even geduld - we laden de pagina' : */'Please wait - we are loading the page';

  mounted() {
    this.$store.commit("setLoading", true);
    this.setConfig();
    this.init();
  }

  private setConfig() {
    this.$store.commit("setConfig", this.configRaw);
    this.$store.commit("setPanelFilterWidgetService");
  }

  public init(): void {
    this.$store.dispatch("loadData");
  }

  public replaceTotalResultsLabel(label: string, totalResults: string) {
    return label ? label.replace("{0}", totalResults) : "";
  }

  public toggleMobileFilters(): void {
    this.mobileFiltersOpened = !this.mobileFiltersOpened;

    if (this.mobileFiltersOpened) {
      document.body.classList.add("vuw-overflow-y-hide");
    } else {
      document.body.classList.remove("vuw-overflow-y-hide");
    }
  }

   private constructExportLink(): string {
     let host = '/api/panelfilterwidget/panelfilterwidgets';
     let language = this.config.language;
     
     let filters: IFilter[] = this.$store.getters.getFilters;
     let selectedFilterOptions: string = '';
     filters.forEach((filter, index) => {
       selectedFilterOptions += filter.code + '=';
       var selectedOptions = filter.options.filter(option => option.checked).map(option => option.code);
       selectedFilterOptions += selectedOptions + ';'
     });
     
     return `${host}/${language}/${this.config.codename}/${selectedFilterOptions}/export`;
   }
}
